import { createSlice } from '@reduxjs/toolkit';
import apiFacebook from '../../api/facebook';
// utils
// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,
  listRecentChat: [],
  conversationContent: [],
  infoUserSelected: null,
  endPage: false,
  endListChat: false,
  listRecentPost:[],
  endListPost:false
};
//
// name : teen store quan li
const slice = createSlice({
  name: 'conversationFacebook',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    statusRefreshInfo(state, action) {
      state.infoUserSelected = false;
      state.conversationContent = [];
    },
    // ACCESS ZALO
    statusSidebarChatSuccess(state, action) {
      const participants = action.payload;
      state.listRecentChat = participants;
      state.isLoading = false;
    },
    statusSidebarPostSuccess(state, action) {
      const participants = action.payload;
      state.listRecentPost = participants;

      state.isLoading = false;
    },
    // ACCESS ZALO
    statusIsSelectedSuccess(state, action) {
      const participants = action.payload;
      state.infoUserSelected = participants;
      state.listRecentChat = state.listRecentChat.map((item, index) => {
        if ((item.to_id === participants?.page_id && item.from_id === participants?.user_id) || (item.to_id === participants?.user_id && item.from_id === participants?.page_id)) {
          item.is_read = 1;
        }
        return item;
      });
      state.isLoading = false;
    },

    statusGetConversationSuccess(state, action) {
      const participants = action.payload;
      state.conversationContent = participants;
      state.isLoading = false;
      state.endPage = false;
    },
    statusLoadMoreMessageSuccess(state, action) {
      const participants = action.payload;
      state.conversationContent = participants.concat(state.conversationContent);
      state.isLoading = false;
      state.endPage = false;
    },
    statusSendMessageLoading(state, action) {
      const participants = action.payload;
      state.conversationContent.push({
        ...participants,
        id_temp: participants.id_temp,
        message_id: participants.message_id,
        time: Date(), src: 1,
        type: participants.type,
        message: participants.message,
        from_id: participants.from_id,
        to_id: participants.to_id,
        display_name: state.infoUserSelected.display_name,
        page_id: participants.page_id,
        attachments: participants?.attachments.length === 0 ? [] : [participants?.attachments],
        attachment_temp_blob: participants?.attachments?.name ? URL.createObjectURL(participants?.attachments) : null,
        is_read: participants.is_read,
        status: participants.status
      });
      state.isLoading = false;
    },
    statusSendMessageFailed(state, action) {
      const participants = action.payload;
      state.conversationContent = state.conversationContent.map((item, index) => {
        if ((item?.id_temp === participants.id_temp)) {
          item.status = participants.status;
          item.err_message = participants.err_message
          delete item.id_temp
        }

        return item;
      });
      //state.conversationContent.push({ message_id: participants.message_id, time: Date(), src: 1, type: "text", message: participants.message, from_id: participants.from_id, to_id: participants.to_id, display_name: state.infoUserSelected.display_name, page_id: participants.page_id, is_read: participants.is_read, status: participants.status, err_message: participants.err_message });
      state.isLoading = false;
    },
    statusSendMessageSuccess(state, action) {
      const participants = action.payload;
      state.conversationContent = state.conversationContent.map((item, index) => {
        if ((item?.id_temp === participants.id_temp)) {
          // Make a shallow copy of the item to avoid mutating the proxy
          const updatedItem = { ...item };
          updatedItem.message_id = participants.message_id;
          updatedItem.status = participants.status;
          delete updatedItem.id_temp;

          // Avoid accessing a revoked proxy in setTimeout by copying necessary values
          const safeMessageId = updatedItem.message_id;

          setTimeout(() => {
            apiFacebook.updateUserResponseMessageItem({ message_id: safeMessageId });
          }, 2500);
          return updatedItem;
          // item.message_id = participants.message_id;
          // item.status = participants.status;
          // delete item.id_temp
        }
        return item;
      });
      //state.conversationContent.push({ message_id: participants.message_id, time: Date(), src: 1, type: "text", message: participants.message, from_id: participants.from_id, to_id: participants.to_id, display_name: state.infoUserSelected.display_name, page_id: participants.page_id, is_read: participants.is_read, status: participants.status });
      state.isLoading = false;
    },
    statusReceiMessageWebhookSuccess(state, action) {
      //if (state.infoUserSelected) {
      const { message_id, message, from_id, to_id, from_display_name, to_display_name, time, attachment_url_image, from_avatar, type, message_short, attachments, to_avatar, page_id, is_read } = action.payload;
      if (state?.infoUserSelected?.user_id == from_id || state?.infoUserSelected?.user_id == to_id) {
        if (!state.conversationContent.some(x => x?.message_id === message_id)) {
          state.conversationContent.push({ from_avatar: from_avatar, to_avatar: to_avatar, from_display_name: from_display_name, to_display_name: to_display_name, to_id: to_id, message_id: message_id, time: time, src: 1, type: type, message: message, from_id: from_id, attachments: attachments, page_id: page_id });
        }
      }
      var index_new_chat = -1;

      state.listRecentChat = state.listRecentChat.map((item, index) => {
        if (message_id != item.message_id) {
          if ((item.to_id === to_id && item.from_id === from_id) || (item.to_id === from_id && item.from_id === to_id)) {
            item.message_short = message_short;
            item.message_id=message_id;
            item.is_read = is_read;
            item.from_id = from_id
            item.from_display_name = from_display_name;
            item.to_display_name = to_display_name;
            item.to_avatar = to_avatar;
            item.from_avatar = from_avatar;
            item.to_id = to_id;
            item.time = time;
            index_new_chat = index;
          }
        }
        return item;
      });
      if (index_new_chat > -1) {
        var newListChatSidebar = state.listRecentChat;
        var temp = newListChatSidebar[index_new_chat];
        delete newListChatSidebar[index_new_chat];
        newListChatSidebar.unshift(temp);
        state.listRecentChat = newListChatSidebar
        // var temp = state.listRecentChat[0];
        // state.listRecentChat[0] = state.listRecentChat[index_new_chat];
        // state.listRecentChat[index_new_chat] = temp;
      } else {
        state.listRecentChat.unshift({ page_id: page_id, from_avatar: from_avatar, to_avatar: to_avatar, from_display_name: from_display_name, to_display_name: to_display_name, attachments: attachments, to_id: to_id, message_id: message_id, time: time, src: 1, type: "text", message_short: message_short, from_id: from_id, to_id: to_id });
      }
      state.isLoading = false;
      //}

    },
    statusLoadMoreListRecentChatSuccess(state, action) {
      const participants = action.payload;
      if (participants) {
        state.listRecentChat = state.listRecentChat.concat(participants);
      } else {
        state.endListChat = true;
      }
      state.isLoading = false;
    },
    statusEndPageSuccess(state, action) {
      state.endPage = true;
    },
    statusRemoveMessageError(state, actioin) {
      state.error = false
    },
    statusListChatEndSuccess(state, action) {
      state.endListChat = true;
    },
    testhaha(state, action) {
      state.conversationContent = []
    }
  }
});

// Reducer
export default slice.reducer;

export function getListRecentChat(pageSelected, param, page) {
  return async (dispatch) => {
    dispatch(slice.actions.statusRefreshInfo());
    try {
      const response = await apiFacebook.getListRecentChat({ pageSelected: pageSelected, paramSearch: param, page: page });
      dispatch(slice.actions.statusSidebarChatSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getListRecentPost(pageSelected, param, page) {
  return async (dispatch) => {
    dispatch(slice.actions.statusRefreshInfo());
    try {
      const response = await apiFacebook.posts({ pageSelected: pageSelected, paramSearch: param, page: page });
      dispatch(slice.actions.statusSidebarPostSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getConversation(infoUserSelected) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      console.log(infoUserSelected);
      const params = {
        name_page: infoUserSelected.name_page,
        avatar_page: infoUserSelected.avatar_page,
        page_id: infoUserSelected.page_id,
        id_conversation: infoUserSelected.id_conversation,
        user_id: infoUserSelected.user_id,
        access_token_page: infoUserSelected.access_token_page,
        avatar: infoUserSelected.avatar_user,
        display_name: infoUserSelected.display_name,
        assign_by: infoUserSelected?.assign_by,
        tag: infoUserSelected?.tag,
        color_tag: infoUserSelected?.color_tag,
      }
      // const response = await apiFacebook.getConversation(params);
      const response = await apiFacebook.getConversationNew(params);
      if (response.data.data) {
        dispatch(slice.actions.statusIsSelectedSuccess(params));
        dispatch(slice.actions.statusGetConversationSuccess(response.data.data));
      }

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// export function selectedConversationSuccess(infoUserSelected) {
//   return async (dispatch) => {

//     const params = {
//       name_page: infoUserSelected.name_page,
//       avatar_page: infoUserSelected.avatar_page,
//       page_id: infoUserSelected.page_id,
//       id_conversation: infoUserSelected.id_conversation,
//       user_id: infoUserSelected.user_id,
//       access_token_page: infoUserSelected.access_token_page,
//       avatar: infoUserSelected.avatar_user,
//       display_name: infoUserSelected.display_name,
//       assign_by: infoUserSelected?.assign_by,
//       tag: infoUserSelected?.tag,
//       color_tag: infoUserSelected?.color_tag,
//     }
//     dispatch(slice.actions.statusIsSelectedSuccess(params));
//   }
// }
export function getMoreMesageConversation(params) {

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await apiFacebook.getConversationNew(params);
      if (response.data?.data) {
        if (response.data.data.length === 0) {
          // dispatch(slice.actions.statusEndPageSuccess());
        } else {
          dispatch(slice.actions.statusLoadMoreMessageSuccess(response.data.data));
        }

      }

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function sendMessage(params) {
  return async (dispatch) => {
    const id_temp = Math.floor(Math.random() * Date.now());
    var param_message = {
      id_temp: id_temp,
      page_id: params.page_id,
      from_avatar: "",
      to_avatar: "",
      from_id: params.page_id,
      from_display_name: "",
      to_display_name: "",
      attachments: params?.attachments,
      to_id: params.user_id,
      message: params.message,
      time: Date(),
      src: 1,
      type: params.contentType,
      message_short: params.message,
      is_read: 1,
      status: -1,
      user_response: params?.user_response
    }
    param_message.status = -1;
    try {
      dispatch(slice.actions.statusSendMessageLoading(param_message, id_temp))
      const response = await apiFacebook.sendMessage(params);
      param_message.status = 1;
      param_message.message_id = response.data.data.message_id;
      dispatch(slice.actions.statusSendMessageSuccess(param_message));
      //{ message_id: response.data.data.message_id, time: Date(), src: 1, type: "text", message: params.message, from_id: params.page_id, to_id: params.user_id }
    } catch (error) {
      console.log(error)
      param_message.status = 0;
      param_message.err_message = error?.response ? error?.response?.data : error.message;
      dispatch(slice.actions.statusSendMessageFailed(param_message));
    }
  };
}
export function receiMessageFromWebhookFacebook(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.statusReceiMessageWebhookSuccess(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response.data));
    }
  };
}
export function loadMoreConversation(param) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const params = { pageSelected: param.pageSelected, page: param.page }
      const response = await apiFacebook.getListRecentChat(params);
      if (response.data?.data) {
        if (response.data.data.length === 0) {
          dispatch(slice.actions.statusListChatEndSuccess());
        } else {
          dispatch(slice.actions.statusLoadMoreListRecentChatSuccess(response.data.data));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function removeMessageError() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.statusRemoveMessageError());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function haha() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      console.log('hohoho')
      dispatch(slice.actions.testhaha());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------




